import { render } from "./EncontrosListPage.vue?vue&type=template&id=4dfc81a6&scoped=true"
import script from "./EncontrosListPage.vue?vue&type=script&lang=js"
export * from "./EncontrosListPage.vue?vue&type=script&lang=js"

import "./EncontrosListPage.vue?vue&type=style&index=0&id=4dfc81a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfc81a6"]])

export default __exports__